import { createClient } from '@supabase/supabase-js';

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey     = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseService = process.env.REACT_APP_SUPABASE_SERVICE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error(
    '❌ Missing Supabase credentials.\n' +
    'Create a .env file from .env.example and fill in your project URL and anon key.'
  );
}

// Hard fetch timeout — prevents Supabase JS client from hanging silently
const fetchWithTimeout = (input, init = {}) => {
  const url = typeof input === 'string' ? input : input?.url || String(input);
  const short = url.replace('https://supabase.trekify.cloud', '');
  console.log('%c→ SB', 'color:#5b9cf6', short);
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 20000);
  return fetch(input, { ...init, signal: controller.signal })
    .then(r => { console.log('%c✓ SB', 'color:#00e5a0', r.status, short); return r; })
    .finally(() => clearTimeout(timeoutId))
    .catch(e => {
      if (e.name === 'AbortError') {
        console.error('%c✗ SB TIMEOUT 6s', 'color:#e05757', short);
      } else {
        console.error('%c✗ SB ERROR', 'color:#e05757', e.message, short);
      }
      throw e;
    });
};

// ── True singletons across HMR ────────────────────────────────────────────────
// React Fast Refresh re-runs this module, which creates new GoTrueClient instances.
// Multiple GoTrue instances share the same Web Lock → deadlock on localStorage.
// Solution: cache instances on globalThis so HMR reuses the same client.

const G = typeof window !== 'undefined' ? window : {};

export const supabase = G.__rfidwms_supabase ||= createClient(supabaseUrl, supabaseKey, {
  auth: {
    storageKey: 'sb-rfidwms-auth',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: { fetch: fetchWithTimeout },
});

export const supabaseAdmin = supabaseService
  ? (G.__rfidwms_supabaseAdmin ||= createClient(supabaseUrl, supabaseService, {
      auth: {
        storageKey: 'sb-rfidwms-admin',
        autoRefreshToken: false,
        persistSession: false,
        detectSessionInUrl: false,
      },
      global: { fetch: fetchWithTimeout },
    }))
  : null;
